module.exports = __webpack_public_path__ + "fonts/OpenSans-Regular.6fde2eb6.woff";